import { ChoiceItem } from "@ingka/choice";

import "@ingka/svg-icon/dist/style.css";
import "@ingka/choice/dist/style.css";
import "@ingka/focus/dist/style.css";
import "@ingka/aspect-ratio-box/dist/style.css";
import "@ingka/image/dist/style.css";
import { ImageAttributes, ImageProps } from "@ingka/image";

interface Props {
  id: string;
  title: string;
  image?: ImageAttributes & ImageProps;
  onClick: (value: any) => void;
}
export const FixaChoiceItem = (props: Props) => {
  return <ChoiceItem {...props} />;
};
